import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const Header = ({ menuState, setMenuState }: any) => {
  const location = useLocation();

  useEffect(() => {
    setMenuState(false);
  }, [setMenuState, location]);

  return (
    <motion.div
      className="header"
      initial={{ opacity: 0, z: 100 }}
      animate={{ opacity: 1, z: 0 }}
      exit={{ opacity: 0, z: -100 }}
      transition={{ duration: 0.5, delay: 0.5 }}
    >
      <div className="logo">
        <Link to="/">
          <p>
            <span>{"["}</span>d<span>{"]"}</span>
          </p>
        </Link>
      </div>
      <div className="menu-btn" onClick={() => setMenuState(!menuState)}>
        <span></span>
        <span></span>
      </div>
    </motion.div>
  );
};

export default Header;
